export class CustomerInvitation {
  customer?: number;
  message?: string;
}
